import assetPath from '/app/packages/lebenslauf/articles/src/assets/delmaine-donson.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')